"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateIndustries = exports.getIndustriesById = exports.getIndustries = exports.deleteIndustries = exports.defaultIndustriesData = exports.createIndustries = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultIndustriesData = exports.defaultIndustriesData = {
  id: 0,
  enabled: true,
  name: ''
};
const getIndustries = params => (0, _request.default)({
  url: '/industries',
  method: 'get',
  params
});
exports.getIndustries = getIndustries;
const getIndustriesById = id => (0, _request.default)({
  url: `/industries/${id}`,
  method: 'get'
});
exports.getIndustriesById = getIndustriesById;
const updateIndustries = (id, data) => (0, _request.default)({
  url: `/industries/${id}`,
  method: 'patch',
  data
});
exports.updateIndustries = updateIndustries;
const deleteIndustries = id => (0, _request.default)({
  url: `/industries/${id}`,
  method: 'delete'
});
exports.deleteIndustries = deleteIndustries;
const createIndustries = data => (0, _request.default)({
  url: '/industries/',
  method: 'post',
  data
});
exports.createIndustries = createIndustries;